import { computed, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class RouterActivityService {
    private readonly router = inject(Router);
    public readonly isNavigating = computed(() => this.router.currentNavigation() !== null);
}
